import styled from 'styled-components';
import { palette } from 'styled-theme';
import BoxComponent from '@iso/components/utility/box';
import WithDirection from '@iso/lib/helpers/rtl';

const BoxWrapper = styled(BoxComponent)`
  .isoCampaignsTableBtn {
    display: flex;
    margin-bottom: 20px;
    a {
      margin-left: auto;
    }
  }
`;

const CardWrapper = styled.div`
  width: auto;
  overflow: inherit;
  position: relative;

  .campanhasListTable {
    .ant-dropdown-menu-item,
    .ant-dropdown-menu-submenu-title {
      &:hover {
        background-color: ${palette('secondary', 1)};
      }
    }

    .peopleViewBtn {
      color: ${palette('text', 3)};

      &:hover {
        color: ${palette('primary', 0)};
      }
    }

    .peopleDltBtn {
      font-size: 18px;
      border: 0;
      color: ${palette('error', 0)};

      &:hover {
        border: 0;
        color: ${palette('error', 2)};
      }
    }
  }
`;

export const ExecucaoTag = styled.span`
  padding: 0 5px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background-color: ${palette('primary', 0)};
  font-size: 12px;
  color: #ffffff;
  text-transform: capitalize;

  &.Executando {
    background-color: ${palette('success', 0)};
  }
`;

const Box = WithDirection(BoxWrapper);
export { Box };
export default WithDirection(CardWrapper);